<template>
    <cs-modal
        :data-component="$options.name"
        channel="real-estate"
        headerText="Filter"
        :visible="isVisible"
        @update:visible="emitClosedModalEvent"
    >
        <cs-accordion
            id="propertyTypes"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Nutzungsart und Immobilientyp"
        >
            <ms-filter-property-type
                :searchFilters="searchFilters"
                :direction="FlexDirection.COLUMN"
            />
        </cs-accordion>
        <cs-accordion
            id="locationArea"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Ort und Umkreis"
        >
            <ms-filter-location-area :locationLevels="locationLevels" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_PRICE_RANGES].id)"
            id="priceRanges"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Preis in Euro"
        >
            <ms-filter-min-max
                :values="filterMinMaxValues[FilterCategoryKey.priceRange]"
                @update:minMaxValue="(newValue) => onUpdateMinMaxValue(newValue, FilterCategoryKey.priceRange)"
            />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_AREA_RANGES].id)"
            id="areaRanges"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Fläche"
        >
            <ms-filter-min-max
                :values="filterMinMaxValues[FilterCategoryKey.areaRange]"
                @update:minMaxValue="(newValue) => onUpdateMinMaxValue(newValue, FilterCategoryKey.areaRange)"
            />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_ROOM_RANGES].id)"
            id="roomRanges"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Zimmer"
        >
            <ms-filter-min-max
                :values="filterMinMaxValues[FilterCategoryKey.roomRange]"
                @update:minMaxValue="(newValue) => onUpdateMinMaxValue(newValue, FilterCategoryKey.roomRange)"
            />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.EQUIPMENT_TYPES].id)"
            id="filterEquipment"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Ausstattung und Merkmale"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.EQUIPMENT_TYPES]" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.FURNISHING_TYPES].id)"
            id="filterFurnishing"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Möblierung"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.FURNISHING_TYPES]" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_CATEGORIES].id)"
            id="filterCategory"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Immobilienkategorien"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.REAL_ESTATE_CATEGORIES]" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.POSITION_TYPES].id)"
            id="filterPosition"
            class="ms-accordion"
            isInitiallyOpen
            hasBorder
            label="Lage"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.POSITION_TYPES]" />
        </cs-accordion>
        <template #buttons>
            <cs-ghost-button
                class="justify-center text-center basis-1/2 min-h-52"
                @click="onClickReset"
            >
                Filter löschen
            </cs-ghost-button>
            <cs-primary-button
                class="basis-1/2 min-h-52"
                :isLoading="isLoading"
                :isDisabled="totalCount === 0"
                isCentered
                @click="emitResultsButtonClicked"
            >
                {{ totalCount }} Ergebnisse
            </cs-primary-button>
        </template>
    </cs-modal>
</template>
<script lang="ts" src="./MsResultListFilterModal.ts" />
<style scoped lang="scss">
.ms-accordion {
    @apply flex flex-col mb-16 px-16 rounded-10 bg-white shadow;
}
</style>
